import { render, staticRenderFns } from "./stockup.vue?vue&type=template&id=c4c7d5a8&scoped=true&"
import script from "./stockup.vue?vue&type=script&lang=js&"
export * from "./stockup.vue?vue&type=script&lang=js&"
import style0 from "./stockup.vue?vue&type=style&index=0&id=c4c7d5a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c7d5a8",
  null
  
)

export default component.exports